
function setView(mode) {
  const container = document.getElementById('wireframeContainer');
  const btnD = document.getElementById('btnDesktop');
  const btnM = document.getElementById('btnMobile');
  const label = document.getElementById('vpLabel');
  if (mode === 'mobile') {
    container.className = 'wireframe-container mobile-view';
    if (btnD) btnD.classList.remove('active');
    if (btnM) btnM.classList.add('active');
    if (label) label.textContent = '390px \u00b7 Mobile';
  } else {
    container.className = 'wireframe-container desktop-view';
    if (btnD) btnD.classList.add('active');
    if (btnM) btnM.classList.remove('active');
    if (label) label.textContent = '1100px \u00b7 Desktop';
  }
}

// Auto-switch class based on actual viewport width (real mobile vs desktop)
(function syncWireframeViewport() {
  var container = document.getElementById('wireframeContainer');
  if (!container) return;
  var mq = window.matchMedia('(max-width: 768px)');
  var sync = function() {
    if (mq.matches) {
      container.classList.remove('desktop-view');
      container.classList.add('mobile-view');
    } else {
      container.classList.remove('mobile-view');
      container.classList.add('desktop-view');
    }
  };
  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync);
  else if (mq.addListener) mq.addListener(sync);
})();
function toggleFaq(el) { el.classList.toggle('open'); }

// COA slider
function scrollCoaSlider(dir) {
  const c = document.getElementById('coaSlider');
  if (!c) return;
  const slide = c.querySelector('.coa-slide');
  const step = slide ? slide.getBoundingClientRect().width : c.clientWidth;
  c.scrollBy({ left: dir * step, behavior: 'smooth' });
}
(function() {
  const c = document.getElementById('coaSlider');
  const dotsWrap = document.getElementById('coaSliderDots');
  const counter = document.getElementById('coaSliderCurrent');
  if (!c || !dotsWrap) return;
  const slides = c.querySelectorAll('.coa-slide');
  slides.forEach((_, i) => {
    const d = document.createElement('span');
    if (i === 0) d.classList.add('active');
    d.addEventListener('click', () => {
      const slide = slides[i];
      c.scrollTo({ left: slide.offsetLeft - c.offsetLeft, behavior: 'smooth' });
    });
    dotsWrap.appendChild(d);
  });
  c.addEventListener('scroll', () => {
    const dots = dotsWrap.querySelectorAll('span');
    let idx = 0; let best = Infinity;
    slides.forEach((slide, i) => {
      const dist = Math.abs(slide.offsetLeft - c.offsetLeft - c.scrollLeft);
      if (dist < best) { best = dist; idx = i; }
    });
    dots.forEach((d, i) => d.classList.toggle('active', i === idx));
    if (counter) counter.textContent = (idx + 1);
  });
})();


// Play a testimonial video inline with controls
function playTestimonialVideo(card) {
  const media = card.querySelector('.video-card-media');
  const v = card.querySelector('video');
  if (!v) return;
  // Pause any others already playing
  document.querySelectorAll('.video-card-media.playing video').forEach(other => {
    if (other !== v) { other.pause(); other.closest('.video-card-media').classList.remove('playing'); other.removeAttribute('controls'); other.muted = true; }
  });
  media.classList.add('playing');
  v.muted = false;
  v.setAttribute('controls', '');
  v.currentTime = 0;
  v.play().catch(() => {});
}

// Video testimonials carousel
function scrollVideoCarousel(dir) {
  const c = document.getElementById('videoCarousel');
  if (!c) return;
  const card = c.querySelector('.video-card');
  const step = card ? card.getBoundingClientRect().width + 20 : 300;
  c.scrollBy({ left: dir * step, behavior: 'smooth' });
}

// Reviews banner — seamless infinite loop (last → first via right side)
let reviewsBannerTimer = null;
let reviewsBannerNormalizing = false;
function _reviewsBannerTileWidth(v) {
  const tile = v.querySelector('.review-banner-tile');
  if (!tile) return 0;
  return tile.getBoundingClientRect().width + 20; // 20px gap
}
function _reviewsBannerHalf(v) {
  // Track contains 2 identical copies back-to-back. halfWidth = width of 1 copy.
  return v.scrollWidth / 2;
}
function _reviewsBannerNormalize(v) {
  const half = _reviewsBannerHalf(v);
  if (half <= 0) return;
  if (v.scrollLeft >= half) {
    reviewsBannerNormalizing = true;
    v.scrollTo({ left: v.scrollLeft - half, behavior: 'auto' });
    requestAnimationFrame(() => { reviewsBannerNormalizing = false; });
  } else if (v.scrollLeft < 0) {
    reviewsBannerNormalizing = true;
    v.scrollTo({ left: v.scrollLeft + half, behavior: 'auto' });
    requestAnimationFrame(() => { reviewsBannerNormalizing = false; });
  }
}
function _reviewsBannerStep(dir) {
  const v = document.getElementById('reviewsBannerViewport');
  if (!v) return;
  const tileWidth = _reviewsBannerTileWidth(v);
  if (!tileWidth) return;
  // For backward steps from the start, pre-warp to mid so the smooth scroll has room
  if (dir < 0 && v.scrollLeft <= 1) {
    const half = _reviewsBannerHalf(v);
    reviewsBannerNormalizing = true;
    v.scrollTo({ left: half, behavior: 'auto' });
    requestAnimationFrame(() => { reviewsBannerNormalizing = false; });
  }
  v.scrollBy({ left: tileWidth * dir, behavior: 'smooth' });
}
function startReviewsBannerAuto() {
  clearInterval(reviewsBannerTimer);
  reviewsBannerTimer = setInterval(() => _reviewsBannerStep(1), 5500);
}
function scrollReviewsBanner(dir) {
  clearInterval(reviewsBannerTimer);
  _reviewsBannerStep(dir);
  setTimeout(startReviewsBannerAuto, 9000);
}
document.addEventListener('DOMContentLoaded', () => {
  const v = document.getElementById('reviewsBannerViewport');
  if (!v) return;
  startReviewsBannerAuto();
  v.addEventListener('mouseenter', () => clearInterval(reviewsBannerTimer));
  v.addEventListener('mouseleave', () => startReviewsBannerAuto());
  // Normalize after every scroll settles so we silently snap back into the first copy
  let normTimer = null;
  v.addEventListener('scroll', () => {
    if (reviewsBannerNormalizing) return;
    clearTimeout(normTimer);
    normTimer = setTimeout(() => _reviewsBannerNormalize(v), 80);
  }, { passive: true });
});
(function() {
  const c = document.getElementById('videoCarousel');
  const dotsWrap = document.getElementById('videoCarouselDots');
  if (!c || !dotsWrap) return;
  const cards = c.querySelectorAll('.video-card');
  // Fill duration tags from video metadata
  cards.forEach(card => {
    const v = card.querySelector('video');
    const tag = card.querySelector('.video-duration-tag');
    if (!v || !tag) return;
    v.addEventListener('loadedmetadata', () => {
      if (!isFinite(v.duration)) return;
      const m = Math.floor(v.duration / 60);
      const s = Math.floor(v.duration % 60).toString().padStart(2, '0');
      tag.textContent = m + ':' + s;
    });
  });
  cards.forEach((_, i) => {
    const d = document.createElement('span');
    if (i === 0) d.classList.add('active');
    d.addEventListener('click', () => {
      const card = cards[i];
      c.scrollTo({ left: card.offsetLeft - c.offsetLeft, behavior: 'smooth' });
    });
    dotsWrap.appendChild(d);
  });
  c.addEventListener('scroll', () => {
    const dots = dotsWrap.querySelectorAll('span');
    let closestIdx = 0; let closestDist = Infinity;
    cards.forEach((card, i) => {
      const dist = Math.abs(card.offsetLeft - c.offsetLeft - c.scrollLeft);
      if (dist < closestDist) { closestDist = dist; closestIdx = i; }
    });
    dots.forEach((d, i) => d.classList.toggle('active', i === closestIdx));
  });
})();

// Reviews "View More" — show 9 at start, batch 9 on click
(function() {
  const grid = document.querySelector('.reviews-grid');
  if (!grid) return;
  // Reorder: photo reviews first, then text-only
  const allCards = Array.from(grid.querySelectorAll('.review-card'));
  const photoCards = allCards.filter(c => c.classList.contains('review-photo-card'));
  const textCards = allCards.filter(c => !c.classList.contains('review-photo-card'));
  [...photoCards, ...textCards].forEach(c => grid.appendChild(c));
  const cards = grid.querySelectorAll('.review-card');
  const btn = document.getElementById('viewMoreBtn');
  let shown = 0;
  const initialBatch = 9;
  const batch = 9;
  const maxShown = 63;

  function showBatch(n) {
    const end = Math.min(shown + n, cards.length, maxShown);
    for (let i = shown; i < end; i++) {
      cards[i].classList.add('visible');
    }
    shown = end;
    if (btn && (shown >= cards.length || shown >= maxShown)) {
      btn.style.display = 'none';
    }
  }
  showBatch(initialBatch);
  window.showMoreReviews = function() { showBatch(batch); };
})();

// Clinical Proof studies carousel
let claimsCarouselTimer = null;
function _claimsCarouselStep(dir) {
  const v = document.getElementById('claimsCarouselViewport');
  if (!v) return;
  const card = v.querySelector('.claim-card');
  if (!card) return;
  const cardWidth = card.getBoundingClientRect().width + 18;
  const maxScroll = v.scrollWidth - v.clientWidth;
  if (dir > 0 && v.scrollLeft + cardWidth > maxScroll - 4) {
    v.scrollTo({ left: 0, behavior: 'auto' });
  } else if (dir < 0 && v.scrollLeft <= 4) {
    v.scrollTo({ left: maxScroll, behavior: 'auto' });
  } else {
    v.scrollBy({ left: cardWidth * dir, behavior: 'smooth' });
  }
}
function startClaimsCarouselAuto() {
  clearInterval(claimsCarouselTimer);
  claimsCarouselTimer = setInterval(() => _claimsCarouselStep(1), 7000);
}
function scrollClaimsCarousel(dir) {
  clearInterval(claimsCarouselTimer);
  _claimsCarouselStep(dir);
  setTimeout(startClaimsCarouselAuto, 10000);
}
document.addEventListener('DOMContentLoaded', () => {
  const v = document.getElementById('claimsCarouselViewport');
  if (!v) return;
  startClaimsCarouselAuto();
  v.addEventListener('mouseenter', () => clearInterval(claimsCarouselTimer));
  v.addEventListener('mouseleave', () => startClaimsCarouselAuto());
});

